import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { useDispatch, useSelector } from 'react-redux';
import SwipeRightIcon from '@mui/icons-material/SwipeRight';
import { Notify } from '../Utility/Notify';
import {
  GetOneClientAction,
  UpdateClientAction,
  UpdateClientActionToReaciveusertolead,
} from '../Redux/Actions/UsersAction';
import { useLocation, useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { GetallLeads_data_With_Email } from '../Redux/Actions/RoleData_Actions';

export const RecievedLeedPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  let usersales = '';
  if (localStorage.getItem('user') != null) {
    usersales = JSON.parse(localStorage.getItem('user'));
  }
  //==============================recive leed
  const [loadingrecivesalestoleed, setloadingrecivesalestoleed] = useState(true);
  const [receiveLoading, setReceiveLoading] = useState(false);

  const location = useLocation();

  const getallleadsforsales = async () => {
    try {
      const searchParams = new URLSearchParams(location.search);
      const stage = searchParams.get('stage');

      let query = '';
      if (stage) query += `&stage=${encodeURIComponent(stage)}`;
      await dispatch(
        GetallLeads_data_With_Email(
          usersales && usersales?.data ? usersales?.data?.email : null,
          query,
        ),
      );
    } catch (error) {
      console.error('Error fetching leads:', error);
    }
  };

  const reciveleedaction = async (e) => {
    e.preventDefault();

    // const formatdata=new FormData()
    // setloadingrecivesalestoleed(true);
    // formatdata.append("assign",false)
    // await dispatch(UpdateClientAction(id,formatdata))
    // setloadingrecivesalestoleed(false)

    setloadingrecivesalestoleed(true);
    setReceiveLoading(true);

    // await dispatch(UpdateClientAction(id,{
    //   assign:false
    // }))
    await dispatch(
      UpdateClientActionToReaciveusertolead(id, {
        assign: false,
      }),
    );

    setloadingrecivesalestoleed(false);
    setReceiveLoading(false);
  };

  const resgetdataforoneleed = useSelector(
    (state) => state.Allusers.updateclient2torecieveusertolead,
  );

  useEffect(() => {
    if (loadingrecivesalestoleed === false) {
      if (resgetdataforoneleed && resgetdataforoneleed.status === 200) {
        Notify('success', 'Successfully updated', 'success');

        setTimeout(() => {
          if (usersales?.data?.role === 'Sales') {
            window.location.href = '#/AllLeadsForSales';
          } else if (usersales?.data?.role === 'Team Leader') {
            window.location.href = '#/AllLeadsForTeamLeader';
          } else if (usersales?.data?.role === 'Manager') {
            window.location.href = '#/LeadsForManagers';
          }

          getallleadsforsales();
        }, 1500);
      } else {
        Notify('error', 'Faild updated', 'error');
        return;
      }
    }
  }, [loadingrecivesalestoleed]);

  //================================================

  //get leed data ---name of leed

  useEffect(() => {
    dispatch(GetOneClientAction(id));
  }, []);
  const resoneleeddata = useSelector((state) => state.Allusers.Get_users);

  let leeddata = [];
  if (resoneleeddata && resoneleeddata.data) {
    leeddata = resoneleeddata.data;
  } else {
    leeddata = [];
  }

  return (
    <Container className="startpage" style={{ marginTop: '50px' }}>
      <div className=" d-flex  w-100">
        <div className="mx-4 ">Recived Leed</div>
        <a style={{ textDecoration: 'none' }} href="/AllLeadsForAdmin" className="goback">
          {'<<'} Go Back{' '}
        </a>
      </div>

      <div style={{ width: '100%', textAlign: 'center' }}>
        <p>
          Hi <span style={{ color: 'royalblue' }}>{usersales.name}</span> ,
        </p>
        <br />
        <div>
          Please Receive The Leed and contact With Him ...Leed Name :
          <span style={{ color: 'royalblue' }}>{leeddata.name}</span> ...
        </div>
        <br />
        <div>Thank You .</div>
        {/* <div onClick={reciveleedaction} className='button-5 w-50 my-4'><SwipeRightIcon/> Okay ,I want To Recieve</div> */}

        <div className="w-100 d-flex justify-content-center " style={{ textAlign: 'center' }}>
          <div
            onClick={!receiveLoading ? reciveleedaction : null}
            className="button-5 d-flex  w-50 my-4"
            style={{
              pointerEvents: receiveLoading ? 'none' : 'auto',
              opacity: receiveLoading ? 0.6 : 1,
              cursor: receiveLoading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              backgroundColor: '#102dff',
            }}
          >
            {receiveLoading ? (
              <CircularProgress size={22} style={{ color: 'white' }} />
            ) : (
              <>
                <SwipeRightIcon /> Okay, I want To Recieve
              </>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};
